import React from 'react'
import { useProjectMember } from '../../Hooks/Features/ProjectGlance/useProjectMember'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { calculateWordsFromString, renderField } from '../../utils/Helper';
import { Dialog } from 'primereact/dialog';
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid';

const ProjectMember = ({ projectData }) => {

    const { categoryData, formJson, handleChange, fieldValues, setFieldValues, showAddInput, setShowAddInput, showPopup, setShowPopup, showInfo, upsertUserRoleAPI, columns, filterValues, setFilterValues, filterData, getProjectMembers } = useProjectMember({ projectData });

    return (
        <div className='h-100'>
            <div>
                <div className='d-flex align-items-center justify-content-between gap-2 fw-semibold'>
                    <div className='d-flex gap-2'>
                        <label className='d-flex align-items-center gap-2'>
                            <input type='radio' className='input-dd' checked={filterValues?.type} onChange={(e) => { setFilterValues(prev => ({ ...prev, type: true })); getProjectMembers(true) }} />
                            Current
                        </label>
                        <labe className='d-flex align-items-center gap-2'>
                            <input type='radio' className='input-dd' checked={!filterValues?.type} onChange={(e) => { setFilterValues(prev => ({ ...prev, type: false })); getProjectMembers(false) }} />
                            Past
                        </labe>
                    </div>
                    <div className='my-2'>
                        {
                            !showAddInput && <button className='sk-btn-primary rounded' onClick={() => setShowAddInput(true)}><FontAwesomeIcon icon="fa-solid fa-plus" /> Add Member</button>
                        }
                    </div>
                </div>
                {
                    showAddInput && <div className='d-flex gap-2 px-2 border rounded my-2'>
                        {
                            formJson?.[0]?.fields?.map((item, index) => {
                                return <div className='w15'>
                                    {renderField(item, index, (e) => { handleChange(item, e) }, fieldValues, {})}
                                </div>
                            })
                        }
                        <div className='d-flex gap-4 align-items-center'>
                            <FontAwesomeIcon icon="fa-solid fa-check" className='text-success c-pointer' onClick={() => upsertUserRoleAPI(fieldValues)} />
                            <FontAwesomeIcon icon="fa-solid fa-close" className='text-danger' onClick={() => setShowAddInput(false)} />
                        </div>
                    </div>
                }
                <div className='d-flex gap-2 flex-wrap align-items-center overflow-auto'>
                    {
                        categoryData?.map((value, index) => {
                            return <div onClick={(e) => {
                                setFilterValues(prev => ({ ...prev, category: value?.category_id }));
                            }} className={`border rounded-pill c-pointer fw-semibold ${filterValues?.category === value?.category_id ? "bg-dark" : ""}`} style={{ padding: "2px 10px " }} key={index}><span style={{ fontSize: "12px" }} className={`${filterValues?.category === value?.category_id ? "text-light" : ""}`} >{value?.category_name}:</span> <span className='px-2' style={{ background: "#E1E6EA", borderRadius: "20px", fontSize: "12px" }}>{value?.category_wise_counts}</span></div>
                        })
                    }
                </div>
            </div>
            <div className='my-2' style={{ height: showAddInput ? "50vh" : "55vh", overflow: "auto" }}>
                {
                    <CommonGrid columns={columns} data={filterData} expandAll={true} strippedTable={true} headerHeight={50} rowHeight={40} />
                }
            </div>
            <Dialog visible={showPopup?.show} onHide={() => { setShowPopup({ show: false }) }} draggable={false} className='modal-xsmall' >
                <div className='notes'>
                    {`The user (${showPopup?.data?.user_display_name}) is  ${showPopup?.data?.is_billable ? " Billable" : "Non-Billable"}. Would you like to update them?`}
                </div>
                <div className='my-2'>
                    <input
                        type="text"
                        value={fieldValues?.remark}
                        placeholder="Enter remark"
                        className='input-text m-0 w100'
                        onChange={(e) => { setFieldValues((prev) => ({ ...prev, remark: e.target.value })) }}
                    />
                    {(calculateWordsFromString(fieldValues?.remark || "") <= 5) ? calculateWordsFromString(fieldValues?.remark || "") + "/5 words" : ""}
                </div>
                <div className="d-flex gap-2 justify-content-center align-items-center py-2 ">
                    <button className='btn-primary' onClick={() => {
                        if (!fieldValues?.remark || calculateWordsFromString(fieldValues.remark) < 5) {
                            showInfo("info", "Remark should contain minimum 5 words.");
                            return;
                        }
                        showPopup?.list && upsertUserRoleAPI({ ...showPopup?.data, remark: fieldValues?.remark }, showPopup?.newValue, "is_billable");
                        setFieldValues((prev) => ({ ...prev, is_billable: showPopup?.newValue }));
                        setShowPopup({ show: false })
                    }}>Save</button>
                    <button className='btn-default' onClick={() => { setShowPopup({ show: false }); }}>Cancel</button>
                </div>
            </Dialog>

        </div>
    )
}

export default ProjectMember
